import React from 'react';
import { BookOpen, Eye } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function SamplePreview() {
  const {
    t
  } = useLanguage();
  const samplePages = [{
    chapter: t('samplePreview.ch3'),
    title: t('samplePreview.ch3Title'),
    desc: t('samplePreview.ch3Desc'),
    color: '#3E2723',
    accent: '#FACC15'
  }, {
    chapter: t('samplePreview.ch5'),
    title: t('samplePreview.ch5Title'),
    desc: t('samplePreview.ch5Desc'),
    color: '#14B8A6',
    accent: '#FBF7F0'
  }, {
    chapter: t('samplePreview.ch8'),
    title: t('samplePreview.ch8Title'),
    desc: t('samplePreview.ch8Desc'),
    color: '#C2410C',
    accent: '#FACC15'
  }];
  return <section className="w-full py-16 md:py-24 bg-[#FBF7F0]" data-id="element-437">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-438">
        <div className="text-center mb-12" data-id="element-439">
          <div className="inline-flex items-center gap-2 bg-[#C2410C] text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-4" data-id="element-440">
            <Eye className="w-3.5 h-3.5" data-id="element-441" />
            {t('samplePreview.badge')}
          </div>
          <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-4" data-id="element-442">
            {t('samplePreview.title')}
          </h2>
          <p className="text-xl text-[#3E2723]/70 max-w-2xl mx-auto" data-id="element-443">
            {t('samplePreview.desc')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-444">
          {samplePages.map((page, idx) => <div key={idx} className="relative bg-white rounded-xl shadow-xl overflow-hidden transform transition-transform hover:-translate-y-2 duration-300" style={{
          rotate: idx === 1 ? '0deg' : idx === 0 ? '-2deg' : '2deg'
        }} data-id="element-445">
              <div className="p-5 text-white" style={{
            backgroundColor: page.color
          }} data-id="element-446">
                <div className="text-xs uppercase tracking-widest mb-1 font-bold" style={{
              color: page.accent
            }} data-id="element-447">
                  {page.chapter}
                </div>
                <h3 className="text-xl font-bold leading-tight" data-id="element-448">
                  {page.title}
                </h3>
              </div>
              <div className="p-5 bg-[#F5F1E8]" data-id="element-449">
                <p className="text-sm text-[#3E2723]/80 italic mb-4" data-id="element-450">
                  "{page.desc}"
                </p>
                <div className="space-y-2 mb-3" data-id="element-451">
                  <div className="h-2 bg-[#3E2723]/15 rounded w-full" data-id="element-452"></div>
                  <div className="h-2 bg-[#3E2723]/15 rounded w-11/12" data-id="element-453"></div>
                  <div className="h-2 bg-[#3E2723]/15 rounded w-4/5" data-id="element-454"></div>
                  <div className="h-2 bg-[#3E2723]/15 rounded w-full" data-id="element-455"></div>
                  <div className="h-2 bg-[#3E2723]/15 rounded w-3/4" data-id="element-456"></div>
                </div>
                <div className="flex items-center gap-2 text-xs font-bold text-[#C2410C] uppercase tracking-wider pt-3 border-t border-[#3E2723]/10" data-id="element-457">
                  <BookOpen className="w-3.5 h-3.5" data-id="element-458" />
                  {t('samplePreview.page')}{' '}
                  {idx === 0 ? '08' : idx === 1 ? '12' : '17'}{' '}
                  {t('samplePreview.of')} 20
                </div>
              </div>
              <div className="absolute inset-0 pointer-events-none" style={{
            background: 'linear-gradient(to top, rgba(251,247,240,0.6) 0%, transparent 30%)'
          }} data-id="element-459"></div>
              <a href="#offer" className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-[#3E2723] hover:bg-[#C2410C] text-white text-xs font-bold px-4 py-2 rounded-full uppercase tracking-wider shadow-lg transition-colors cursor-pointer whitespace-nowrap" data-id="element-460">
                {t('samplePreview.unlock')}
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}